module.exports={
	"Form": "EquipmentViewManifest",
	"Scope": "Equipment-View",
	"Descriptors":
	{
		"EquipmentDetails.Name":
		{
			"Name": "Name",
			"Hash": "Equipment-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Equipment-View-Identity",
				"Group": "Equipment-View-Identity"
			}
		},
		"EquipmentDetails.Code":
		{
			"Name": "Code",
			"Hash": "Equipment-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Equipment-View-Identity",
				"Group": "Equipment-View-Identity"
			}
		},
		"EquipmentDetails.Description":
		{
			"Name": "Description",
			"Hash": "Equipment-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "Equipment-View-Details",
				"Group": "Equipment-View-Details"
			}
		},
		"EquipmentDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Equipment-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "Equipment-View-Details",
				"Group": "Equipment-View-Details"
			}
		},
		"EquipmentDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "Equipment-View-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-View-Details",
				"Group": "Equipment-View-Details"
			}
		},
		"EquipmentDetails.Status":
		{
			"Name": "Status",
			"Hash": "Equipment-View-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-View-Details",
				"Group": "Equipment-View-Details"
			}
		},
		"EquipmentDetails.ExternalEquipmentID":
		{
			"Name": "External Equipment ID",
			"Hash": "Equipment-View-ExternalEquipmentID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-View-Details",
				"Group": "Equipment-View-Details"
			}
		},
		"EquipmentDetails.IDEquipment":
		{
			"Name": "IDEquipment",
			"Hash": "Equipment-View-IDEquipment",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		},
		"EquipmentDetails.GUIDEquipment":
		{
			"Name": "GUIDEquipment",
			"Hash": "Equipment-View-GUIDEquipment",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		},
		"EquipmentDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Equipment-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		},
		"EquipmentDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Equipment-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		},
		"EquipmentDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Equipment-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		},
		"EquipmentDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Equipment-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Equipment-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Equipment-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Equipment-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Equipment-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Equipment-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Equipment-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
